import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card';
import { GetAssignmentActionList } from '../../../../store/HR/Payroll/runPayrollSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';
// import NeatixModal from '../../../../../components/Modal/NeatixModal';
import NtxCustomModal from '../../../../components/Modal/NtxCustomModal';

const AssignmentAction = () => {
  const [show, setShow] = useState(false);
  const [empData, setEmpData] = useState({});
  const { payrollId } = useParams();
  const { PayrollActionId } = useParams();
  const { t, i18n } = useTranslation();

  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.runPayroll);
  const AssignmentActionList = useSelector((state) => state.runPayroll.AssignmentActionList);

  // console.log(JSON.stringify(empData));

  useEffect(() => {
    dispatch(GetAssignmentActionList(PayrollActionId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { title: t('EmployeeName'), key: 'Name' },
    { title: t('Job'), key: 'job' },
    { title: t('الإستحقاقات'), key: 'earnings', className: ' text-success fw-bold' },
    { title: t('الإستقطاعات'), key: 'deductions', className: ' text-danger fw-bold' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false },
  ];

  const tableData = AssignmentActionList?.map((emp) => {
    // let rowClass;
    const { name, name2, jobName2, jobName, runResultsList } = emp;

    // حساب الإستقطاعات والإستحقاقات
    const { earnings, deductions } = runResultsList?.reduce(
      (totals, item) => {
        if (item.isEarning) {
          totals.earnings += item.resultValue;
        } else {
          totals.deductions += item.resultValue;
        }
        return totals;
      },
      { earnings: 0, deductions: 0 }
    );

    return {
      Name: i18n.language === 'ar' ? name2 : name,
      job: i18n.language === 'ar' ? jobName2 : jobName,
      earnings: earnings,
      deductions: deductions,
      action: (
        <div className="btn-group">
          <button
            type="button"
            onClick={() => handleOpenTab(emp)}
            className="btn btn-sm btn-outline-theme">
            <i className="fas fa-lg fa-fw me-2 fa-print"></i>
            {t('Print')}
          </button>
          <button
            type="button"
            onClick={() => {
              setEmpData(emp);
              setShow(true);
            }}
            className="btn btn-sm btn-outline-theme">
            <i className="fas fa-lg fa-fw me-2 fa-print"></i>
            {t('show')}
          </button>
        </div>
      ),
    };
  });

  // console.log(data);

  const handleOpenTab = (item) => {
    localStorage.setItem('personName2', item.name2);
    localStorage.setItem('personName', item.name);
    const newWindow = window.open(
      `/Report/${item.id}/PayrollForPerson`,
      '_blank',
      'width=1000,height=800'
    );
    newWindow.focus();
  };

  //#region useLocation
  const location = useLocation();
  const [referenceName, setReferenceName] = useState(null); // State to hold ReferenceName
  useEffect(() => {
    if (location.state && location.state.ReferenceName) {
      const { ReferenceName } = location.state;
      if (ReferenceName) {
        setReferenceName(ReferenceName); // Update ReferenceName state
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('RunPayrolls'),
      link: '/Pay/payrollsRun',
    },
    {
      name: t('ShowAllRuns'),
      link: `/Pay/payrollsRun/${payrollId}/ActionList`,
      //
    },

    {
      name: t('SalaryStatement'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb
          BreadcrumbList={BcrumbList}
          PageName={t('SalaryStatement')}
          subtitle={referenceName}
        />
        <div className="ms-auto">
          <div className="btn-group">
            <button
              onClick={() => Navigate(-1, { replace: true })}
              type="button"
              className=" btn me-1 btn-default">
              {/* <i className="fa fa-power-off fa-fw me-1"></i>  */}
              {t('Back')}
            </button>
            <button
              type="button"
              onClick={() => {
                const newWindow = window.open(
                  `/Report/${PayrollActionId}/PayrollForAll`,
                  '_blank',
                  'width=1300,height=700'
                );
                newWindow.focus();
              }}
              className="btn btn-theme">
              <i className="fas fa-lg fa-fw me-2 fa-print"></i>
              {t('PrintAll')}
            </button>
          </div>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NtxCustomModal
        width="97%"
        show={show}
        setShow={setShow}
        showHeader={false}
        bodyClassName="p-0">
        <Card>
          <CardBody>
            <EmployeeDetails empData={empData} onClose={() => setShow(false)} />
          </CardBody>
        </Card>
      </NtxCustomModal>
    </>
  );
};

export default AssignmentAction;

const EmployeeDetails = ({ empData, onClose }) => {
  const { t } = useTranslation();

  // التحقق من وجود البيانات
  const name = empData?.name2 || 'غير متوفر';
  const jobName = empData?.jobName2 || 'غير متوفر';
  // const iBan = empData?.iBan || 'غير متوفر';

  const runResultsList = empData?.runResultsList || [];

  const [earnings, setEarnings] = useState(runResultsList.filter((item) => item.isEarning));
  const [deductions, setDeductions] = useState(runResultsList.filter((item) => !item.isEarning));

  // حساب الإجماليات
  const totalEarnings = earnings.reduce((total, item) => total + (item?.resultValue || 0), 0);
  const totalDeductions = deductions.reduce((total, item) => total + (item?.resultValue || 0), 0);

  // ~~~~
  // حالة لتتبع العناصر التي يتم تعديلها
  const [editState, setEditState] = useState({});
  const [editValues, setEditValues] = useState({});

  const [deductionsEditState, setDeductionsEditState] = useState({});
  const [deductionsEditValues, setDeductionsEditValues] = useState({});

  const handleEdit = (index, type) => {
    if (type === 'earnings') {
      setEditState((prev) => ({ ...prev, [index]: true }));
      setEditValues((prev) => ({ ...prev, [index]: earnings[index]?.resultValue || 0 }));
    } else {
      setDeductionsEditState((prev) => ({ ...prev, [index]: true }));
      setDeductionsEditValues((prev) => ({
        ...prev,
        [index]: deductions[index]?.resultValue || 0,
      }));
    }
  };

  const handleCancel = (index, type) => {
    if (type === 'earnings') {
      setEditState((prev) => ({ ...prev, [index]: false }));
      setEditValues((prev) => ({ ...prev, [index]: earnings[index]?.resultValue }));
    } else {
      setDeductionsEditState((prev) => ({ ...prev, [index]: false }));
      setDeductionsEditValues((prev) => ({ ...prev, [index]: deductions[index]?.resultValue }));
    }
  };

  const handleSave = (index, type) => {
    if (type === 'earnings') {
      setEarnings((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          resultValue: editValues[index],
        };
        return updated;
      });
      setEditState((prev) => ({ ...prev, [index]: false }));
    } else {
      setDeductions((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          resultValue: deductionsEditValues[index],
        };
        return updated;
      });
      setDeductionsEditState((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleChange = (index, value, type) => {
    if (type === 'earnings') {
      setEditValues((prev) => ({ ...prev, [index]: parseFloat(value) || 0 }));
    } else {
      setDeductionsEditValues((prev) => ({ ...prev, [index]: parseFloat(value) || 0 }));
    }
  };

  // const handleEdit = (index) => {
  //   setEditState((prev) => ({ ...prev, [index]: true })); // دخول وضع التعديل
  //   setEditValues((prev) => ({ ...prev, [index]: earnings[index]?.resultValue || 0 })); // نسخ القيمة الحالية
  // };

  // const handleCancel = (index) => {
  //   setEditValues((prev) => {
  //     const updatedValues = Array.isArray(prev) ? [...prev] : [];
  //     updatedValues[index] = earnings[index]?.resultValue; // revert to original value
  //     return updatedValues;
  //   });
  //   setEditState((prev) => ({ ...prev, [index]: false }));
  // };

  //  const handleSave = (index) => {
  //   setEarnings((prev) => {
  //     const updated = [...prev];
  //     updated[index] = {
  //       ...updated[index],
  //       resultValue: editValues[index],
  //     };
  //     return updated;
  //   });
  //   setEditState((prev) => ({ ...prev, [index]: false }));
  // };

  // const handleChange = (index, value) => {
  //   setEditValues((prev) => ({ ...prev, [index]: parseFloat(value) || 0 }));
  // };

  return (
    <>
      <div className="">
        <div className="row mb-3">
          {/* Name */}
          <div className="col-12 col-md-8 mb-3 mb-md-0">
            <div className="bg-inverse bg-opacity-10 rounded-2 p-3 mb-2 border">
              <div className="d-flex justify-content-between align-items-center">
                <div className="mb-0">
                  <i className="fas fa-user text-theme me-2"></i>
                  <span className="text-inverse text-opacity-50 fw-bold">{t('Name')}:</span>
                  <span className="text-theme h6 m-2">{name}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Employee Number */}
          <div className="col-12 col-md-4 mb-3 mb-md-0">
            <div className="bg-inverse bg-opacity-10 rounded-2 p-3 mb-2 border">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-center">
                  <i className="fas fa-id-badge text-theme me-2"></i>
                  <span className="text-inverse text-opacity-50 fw-bold">
                    {t('EmployeeNumber')}:
                  </span>
                  <span className="text-theme h6 m-2">00000000000</span>
                </div>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="col-12 col-md-4 mb-3 mb-md-0">
            <div className="bg-inverse bg-opacity-10 rounded-2 p-3 mb-2 border">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-center">
                  <i className="fas fa-map-marker-alt text-theme me-2"></i>
                  <span className="text-inverse text-opacity-50 fw-bold">{t('location')}:</span>
                  <span className="text-theme h6 m-2">العليا - الريـاض</span>
                </div>
              </div>
            </div>
          </div>

          {/* Job */}
          <div className="col-12 col-md-4 mb-3 mb-md-0">
            <div className="bg-inverse bg-opacity-10 rounded-2 p-3 mb-2 border">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-center">
                  <i className="fas fa-briefcase text-theme me-2"></i>
                  <span className="text-inverse text-opacity-50 fw-bold">{t('Job')}:</span>
                  <span className="text-theme h6 m-2">{jobName}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="row">
          {/* جدول الإستحقاقات */}
          <div className="col-12 col-md-6 mb-3">
            <h5 className="text-success">
              <i className="fas fa-lg fa-plus-circle me-2"></i> الإستحقاقات
            </h5>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="bg-success bg-opacity-30">
                  <tr>
                    <th style={{ width: '40%' }}>{t('Description')}</th>
                    <th style={{ width: '15%' }}>{t('من')}</th>
                    <th style={{ width: '15%' }}>{t('إلى')}</th>
                    <th className="text-center" style={{ width: '15%' }}>
                      {t('Value')}
                    </th>
                    <th className="text-center" style={{ width: '15%' }}>
                      {t('Actions')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {earnings?.slice()?.map((item, index) => (
                    <tr key={index} style={{ height: '50px' }}>
                      <td className="align-middle">{item?.elementTypeName2 || 'غير متوفر'}</td>
                      <td className="align-middle">{item?.startDate || 'غير متوفر'}</td>
                      <td className="align-middle">{item?.endDate || 'غير متوفر'}</td>
                      <td className="align-middle text-center">
                        {editState[index] ? (
                          <input
                            type="text"
                            className="form-control border-2 border-theme fw-bold text-center p-0"
                            style={{
                              width: '100%',
                              height: '100%',
                              boxSizing: 'border-box',
                            }}
                            value={editValues[index]}
                            onChange={(e) => handleChange(index, e.target.value, 'earnings')}
                          />
                        ) : (
                          item.resultValue
                        )}
                      </td>
                      <td className="text-center align-middle">
                        {editState[index] ? (
                          <>
                            <Link
                              className="text-decoration-none text-success"
                              onClick={() => handleSave(index, 'earnings')}>
                              {false ? (
                                <div className="spinner-grow spinner-grow-sm"></div>
                              ) : (
                                <i className="fas fa-lg fa-fw fa fa-save"></i>
                              )}
                            </Link>
                            <Link
                              className="text-decoration-none text-danger ms-3"
                              onClick={() => handleCancel(index, 'earnings')}>
                              <i className="fas fa-lg fa-fw fa-times"></i>
                            </Link>
                          </>
                        ) : (
                          <Link
                            className="text-decoration-none text-theme text-center "
                            onClick={() => handleEdit(index, 'earnings')}>
                            <i className="fas fa-lg fa-fw fa-edit"></i>
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                  {earnings.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        {t('NoEarnings')}
                      </td>
                      <td className="text-center"></td>
                    </tr>
                  )}
                  {/* الإجمالي */}
                  <tr>
                    <td colSpan={3} className="text-end fw-bold">
                      {t('Total')}
                    </td>
                    <td className="fw-bold text-success text-center">{totalEarnings}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* جدول الإستقطاعات */}
          <div className="col-12 col-md-6 mb-3">
            <h5 className="text-danger">
              <i className="fas fa-lg fa-minus-circle me-2"></i> الإستقطاعات
            </h5>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="bg-danger bg-opacity-30">
                  <tr>
                    <th style={{ width: '40%' }}>{t('Description')}</th>
                    <th style={{ width: '15%' }}>{t('من')}</th>
                    <th style={{ width: '15%' }}>{t('إلى')}</th>
                    <th className="text-center" style={{ width: '15%' }}>
                      {t('Value')}
                    </th>
                    <th className="text-center" style={{ width: '15%' }}>
                      {t('Actions')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deductions?.slice()?.map((item, index) => (
                    <tr key={index} style={{ height: '50px' }}>
                      <td className="align-middle">{item?.elementTypeName2 || 'غير متوفر'}</td>
                      <td className="align-middle">{item?.startDate || 'غير متوفر'}</td>
                      <td className="align-middle">{item?.endDate || 'غير متوفر'}</td>
                      <td className="align-middle text-center">
                        {deductionsEditState[index] ? (
                          <input
                            type="text"
                            className="form-control border-2 border-theme fw-bold text-center p-0"
                            style={{
                              width: '100%',
                              height: '100%',
                              boxSizing: 'border-box',
                            }}
                            value={deductionsEditValues[index]}
                            onChange={(e) => handleChange(index, e.target.value, 'deductions')}
                          />
                        ) : (
                          item.resultValue
                        )}
                      </td>
                      <td className="text-center align-middle">
                        {deductionsEditState[index] ? (
                          <>
                            <Link
                              className="text-decoration-none text-success"
                              onClick={() => handleSave(index, 'deductions')}>
                              <i className="fas fa-lg fa-fw fa fa-save"></i>
                            </Link>
                            <Link
                              className="text-decoration-none text-danger ms-3"
                              onClick={() => handleCancel(index, 'deductions')}>
                              <i className="fas fa-lg fa-fw fa-times"></i>
                            </Link>
                          </>
                        ) : (
                          <Link
                            className="text-decoration-none text-theme text-center "
                            onClick={() => handleEdit(index, 'deductions')}>
                            <i className="fas fa-lg fa-fw fa-edit"></i>
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                  {deductions.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        {t('NoEarnings')}
                      </td>
                      <td className="text-center"></td>
                    </tr>
                  )}
                  {/* الإجمالي */}
                  <tr>
                    <td colSpan={3} className="text-end fw-bold">
                      {t('Total')}
                    </td>
                    <td className="fw-bold text-success text-center">{totalDeductions}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex gap-3 flex-column flex-md-row">
        <button type="submit" className="btn btn-lg btn-theme w-100">
          {false ? (
            <div className="spinner-border spinner-border-sm me-2"></div>
          ) : (
            <i className="fa fa-save fa-fw me-2"></i>
          )}
          {t('Save')}
        </button>

        <button type="button" className="btn btn-lg btn-default w-100" onClick={onClose}>
          <i className="fa fa-power-off fa-fw me-2"></i> {t('Cancel')}
        </button>
      </div>
    </>
  );
};
